// @ts-nocheck
import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";
// import StyledWrapper from "@insite/client-framework/Common/StyledWrapper"; // Valtech Custom Code
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getCategoriesDataView,
    getCategoryState,
    getSubCategoryIds,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadCategories from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridWidths } from "@insite/mobius/GridItem";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

/* Valtech Custom Code - Start */
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import getColor from "@insite/mobius/utilities/getColor";
import getTextAlignmentField, { textAlignmentOptions } from "@store/Framework/Common/Fields/Toolkit/textAlignment";
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import { categoryListProps } from "@store/Themes/common/props/category";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import {
    DataOption,
    DataOptions,
    getDataOptionsFieldDefinition,
} from "@toolkit/Framework/Common/Utilities/dataOptions";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { getSettingsCollection } from "@toolkit/Framework/Store/Context/ContextSelectors";
import { LiteralUnion } from "@toolkit/Framework/Types/Common";
import { gridGapStyles, overrideSpacingStyles } from "@toolkit/Themes/common/mixins";
import sortBy from "lodash/sortBy";

const StyledSpan = getStyledWrapper("span");

export type CategoryListVariantOption = DataOption;
export interface CategoryListVariantOptionMapper {
    standard: CategoryListVariantOption;
    compact: CategoryListVariantOption;
}
export type CategoryListVariantOptions = DataOptions<CategoryListVariantOption> & CategoryListVariantOptionMapper;
export type CategoryListVariant = LiteralUnion<keyof CategoryListVariantOptionMapper>;

export const categoryListVariantOptions: CategoryListVariantOptions = {
    standard: { id: "standard", displayName: "Standard", isDefault: true },
    compact: { id: "compact", displayName: "Compact" },
};
/* Valtech Custom Code - End */

/* Hercules Custom Code - Start */
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import ArrowRight from "@insite/mobius/Icons/ArrowRight";
import HeadingComponent, { HeadingProps } from "@store/Library/Components/Toolkit/Heading";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
/* Hercules Custom Code - End */

const enum fields {
    showImages = "showImages",
    showOnlyTopLevelCategories = "showOnlyTopLevelCategories",
    // Valtech Custom Code
    selectedCategoryIds = "selectedCategoryIds",
    showSubCategories = "showSubCategories",
    subCategoriesToShow = "subCategoriesToShow",
    title = "title",
    titleAlignment = "titleAlignment",
    variant = "variant",
    /* Hercules Custom Code - Start */
    addSpacing = "addSpacing",
    showTitle = "showTitle",
    forwardAs = "forwardAs",
    textAlign = "textAlign",
    /* Hercules Custom Code - End */
}

/* Valtech Custom Code - Start */
const titleAlignmentField = getTextAlignmentField(fields.titleAlignment);
/* Valtech Custom Code - End */

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showImages]: boolean;
        [fields.showOnlyTopLevelCategories]: boolean;
        // Valtech Custom Code
        [fields.selectedCategoryIds]: string[];
        [fields.showSubCategories]: boolean;
        [fields.subCategoriesToShow]: number;
        /* Hercules Custom Code - Start */
        [fields.title]: HeadingProps["title"];
        /* Hercules Custom Code - End */
        [fields.titleAlignment]: string;
        /* Hercules Custom Code - Start */
        [fields.variant]: HeadingProps["variant"];
        [fields.addSpacing]: boolean;
        [fields.showTitle]: boolean;
        [fields.forwardAs]: HeadingProps["forwardAs"];
        [fields.textAlign]: HeadingProps["textAlign"];
        /* Hercules Custom Code - End */
    };
}

const mapStateToProps = (state: ApplicationState, props: OwnProps) => {
    const getCategoriesParameter = {
        // Valtech Removed - maxDepth
        includeStartCategory: false,
    };
    return {
        categoriesDataView: getCategoriesDataView(state, getCategoriesParameter),
        getCategoriesParameter,
        topLevelCategoryIds: getSubCategoryIds(state, emptyGuid) || [], // Valtech Custom Code
        // Valtech Custom Code
        defaultImagePath: getSettingsCollection(state).extensionCatalogSettings?.notFoundCategorySmallImagePath,
    };
};

const mapDispatchToProps = {
    loadCategories,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme>;

export interface CategoryListStyles {
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    container?: GridContainerProps;
    categoryItem?: GridItemProps;
    innerContainer?: GridContainerProps;
    categoryImageItem?: GridItemProps;
    categoryImageLink?: LinkPresentationProps;
    categoryImage?: LazyImageProps;
    categoryNameLinkItem?: GridItemProps;
    categoryNameLink?: LinkPresentationProps;
    categoryName?: TypographyProps;
    subCategoryNameLinkItem?: GridItemProps;
    subCategoryNameLink?: LinkPresentationProps;
    viewMoreLinkItem?: GridItemProps;
    viewMoreLink?: LinkPresentationProps;
    // Valtech Custom Code
    wrapper?: InjectableCss;
    title?: TypographyProps;
    loadingOverlay?: LoadingOverlayProps;
    categoryLink?: LinkPresentationProps;
    categoryImageWrapper?: InjectableCss;
    subCategoryList?: TypographyProps;
    subCategoryListItem?: TypographyProps;
    /* Hercules Custom Code - Start */
    icon?: IconPresentationProps;
    iconItem?: GridItemProps;
    /* Hercules Custom Code - End */
}

export const categoryListStyles: CategoryListStyles = {
    /* Hercules Custom Code - Start */
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    container: {
        gap: 20,
    },
    categoryItem: {
        /* Hercules Custom Code - Start */
        width: [12, 12, 3, 3, 3],
        /* Hercules Custom Code - End */
    },
    innerContainer: {
        gap: 0,
        offsetCss: css`
            ${gridGapStyles(pxToRemArray([0, null, 30, null, null]))}
            cursor: pointer;
            flex-wrap: initial !important; /* Hercules Custom Code - for some reason I have to add important otherwise the flex-wrap isn't working */
            align-items: center;
            padding: ${pxToRem(16)};
            border: ${pxToRem(1)} solid ${getColor("common.borderLight")};
        `,
    },
    categoryImageItem: {
        width: [3, 3, 5, 5, 5],
        css: css`
            align-items: center;
            height: 100px;
            ${breakpoint("sm", "down")} {
                height: 50px;
            }
        `,
    },
    iconItem: {
        width: 1,
        css: css`
            padding-bottom: 0;
            ${breakpoint("md", "up")} {
                align-self: flex-end;
            }
        `,
    },
    categoryImage: {
        css: css`
            ${x => x.theme.lazyImage.defaultProps?.css}
            height: 100px;
            width: 100px;
            ${breakpoint("md", "only")} {
                height: 75px;
                width: 75px;
            }
            ${breakpoint("sm", "down")} {
                height: 50px;
                width: 50px;
            }
        `,
    },
    categoryNameLinkItem: {
        width: [8, 8, 6, 6, 6],
        css: css`
            padding-bottom: ${pxToRem(8)};
        `,
    },
    categoryName: {
        css: css`
            color: ${getColor("text.link")};
            font-weight: bold;
        `,
    },
    subCategoryNameLinkItem: {
        width: 12,
    },
    viewMoreLinkItem: {
        width: 12,
        css: css`
            font-weight: bold;
            padding-top: ${pxToRem(10)};
        `,
    },
    icon: {
        src: ArrowRight,
        color: "text.link",
    },
    /* Hercules Custom Code - End */
};

/* Valtech Custom Code - Start */
export const categoryListCompactStyles: CategoryListStyles = {
    title: categoryListProps.title,
    container: {
        gap: 0,
        offsetProps: {
            as: "ul",
        },
        css: gridGapStyles(pxToRemArray([20, null, 30])),
    },
    categoryItem: {
        as: "li",
        width: [6, 4, 3, 2.4 as any, 2],
    },
    categoryLink: mergeProps<CategoryListStyles["categoryLink"]>(categoryListProps.itemLink, {
        css: css`
            padding: ${pxToRem(15)};
            border: 1px solid ${getColor("common.border")};
        `,
    }),
    categoryImageWrapper: categoryListProps.itemImageWrapper,
    categoryImage: categoryListProps.itemImage,
    categoryName: mergeProps<CategoryListStyles["categoryName"]>(categoryListProps.itemTitle, {
        forwardAs: "h3",
        css: css`
            ${overrideSpacingStyles(pxToRem(15), null)}
            padding: 0;
        `,
    }),
};
/* Valtech Custom Code - End */

const styles = categoryListStyles;

class CategoryList extends React.Component<Props> {
    container = React.createRef<HTMLDivElement>();
    /* Hercules Custom Code - Start */
    categoryItemStyles: GridItemProps = { ...styles.categoryItem };
    /* Hercules Custom Code - End */

    UNSAFE_componentWillMount(): void {
        const { categoriesDataView, getCategoriesParameter, loadCategories } = this.props;
        if (!categoriesDataView.isLoading && !categoriesDataView.value) {
            loadCategories(getCategoriesParameter);
        }
    }

    // Valtech Removed - recalculateWidth

    componentDidMount() {
        // Valtech Removed - recalculateWidth
        // Valtech Removed - addEventListener
    }

    componentWillUnmount() {
        // Valtech Removed - removeEventListener
    }

    componentDidUpdate(prevProps: Props) {
        // Valtech Removed - recalculateWidth
    }

    /* Hercules Custom Code - Start */
    handleClick = (link: string) => {
        window.location.href = link;
    };
    /* Hercules Custom Code - End */

    render() {
        const {
            categoriesDataView,
            topLevelCategoryIds,
            fields: {
                showImages,
                showOnlyTopLevelCategories,
                // Valtech Custom Code
                selectedCategoryIds,
                showSubCategories: baseShowSubCategories,
                subCategoriesToShow: baseSubCategoriesToShow,
                title,
                titleAlignment,
                variant,
                /* Hercules Custom Code - Start */
                addSpacing,
                showTitle,
                forwardAs,
                textAlign,
                /* Hercules Custom Code - End */
            },
            // Valtech Custom Code
            defaultImagePath,
        } = this.props;
        /* Valtech Custom Code - Start */
        const isCompact = variant === categoryListVariantOptions.compact.id;
        const styles = isCompact ? categoryListCompactStyles : categoryListStyles;
        /* Valtech Custom Code - End */

        if (categoriesDataView.isLoading) {
            /* Hercules Custom Code - Start */
            return (
                <StyledWrapper {...styles.centeringWrapper}>
                    <LoadingSpinner {...styles.spinner} />
                </StyledWrapper>
            );
            /* Hercules Custom Code - End */
        }

        if (!categoriesDataView.value || !topLevelCategoryIds) {
            /* Hercules Custom Code - Start */
            return null;
            /* Hercules Custom Code - End */
        }

        /* Valtech Custom Code - Start */
        const showSubCategories = baseShowSubCategories && !isCompact;
        const subCategoriesToShow = baseSubCategoriesToShow || 4;

        const titleCss = css`
            ${styles.title?.css}
            ${cssProp("text-align", titleAlignment)}
        `;

        const linkCss = css`
            ${styles.categoryLink?.css}
            ${showSubCategories && "height: auto;"}
        `;

        let categories = categoriesDataView.value?.filter(o =>
            (showOnlyTopLevelCategories ? topLevelCategoryIds : selectedCategoryIds).includes(o.id),
        );

        if (!showOnlyTopLevelCategories) {
            categories = sortBy(categories, ["shortDescription"]);
        }

        /* Hercules Custom Code - Start */
        const wrapperStyles = mergeProps<CategoryListStyles["wrapper"]>(styles.wrapper, {
            css: addSpacing
                ? css`
                      ${x => breakpointValues(x.theme.design.layout.spacing.content, ["margin-top", "margin-bottom"])}
                  `
                : css``,
        });
        // const categories = categoriesDataView.value.filter(o => topLevelCategoryIds.indexOf(o.id) > -1);

        return (
            <StyledWrapper ref={this.container} {...wrapperStyles}>
                {showTitle && (
                    <HeadingComponent
                        title={title}
                        variant={variant}
                        forwardAs={forwardAs}
                        textAlign={textAlign}
                        verticalAlign="middle"
                    ></HeadingComponent>
                )}
                <GridContainer {...styles.container}>
                    {categories.map(category => (
                        <GridItem key={category.id.toString()} {...this.categoryItemStyles}>
                            <GridContainer onClick={() => this.handleClick(category.path)} {...styles.innerContainer}>
                                {showImages && (
                                    <GridItem {...styles.categoryImageItem}>
                                        {category.path && (
                                            <LazyImage
                                                src={category.smallImagePath}
                                                {...styles.categoryImage}
                                                altText={category.imageAltText}
                                            />
                                        )}
                                    </GridItem>
                                )}
                                <GridItem {...styles.categoryNameLinkItem}>
                                    <Typography {...styles.categoryName}>{category.shortDescription}</Typography>
                                </GridItem>
                                <GridItem {...styles.iconItem}>
                                    <Icon {...styles.icon} />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    ))}
                </GridContainer>
            </StyledWrapper>
        );
        /* Hercules Custom Code - End */
        /* Valtech Custom Code - End */
    }
}

const SubCategoryLinkView = ({
    category,
    // Valtech Custom Code
    styles,
}: ReturnType<typeof linkMapStateToProps>) => {
    if (!category) {
        return null;
    }

    return (
        <Link href={category.path} {...styles.subCategoryNameLink}>
            {category.shortDescription}
        </Link>
    );
};

const linkMapStateToProps = (
    state: ApplicationState,
    ownProps: {
        categoryId: string;
        // Valtech Custom Code
        styles: CategoryListStyles;
    },
) => ({
    category: getCategoryState(state, ownProps.categoryId).value,
    // Valtech Custom Code
    styles: ownProps.styles,
});

const SubCategoryLink = connect(linkMapStateToProps)(SubCategoryLinkView);

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withTheme(CategoryList)),
    definition: {
        group: "Categories",
        icon: "list-ul",
        // Valtech Removed - allowedContexts
        fieldDefinitions: [
            /* Valtech Custom Code - Start */
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                /* Hercules Custom Code - Start */
                defaultValue: "Shop by category",
                /* Hercules Custom Code - End */
                fieldType: "Contextual",
                /* Hercules Custom Code - Start */
                isRequired: true,
                isVisible: x => x.fields.showTitle,
                /* Hercules Custom Code - End */
            },
            {
                ...titleAlignmentField.definition,
                displayName: "Title Alignment",
                defaultValue: textAlignmentOptions.center.id,
                fieldType: "Contextual",
                isVisible: x => Boolean(x.fields.title),
            },
            {
                /* Hercules Removed Code - getDataOptionsFieldDefinition */
                name: fields.variant,
                /* Hercules Custom Code - Start */
                displayName: "Format",
                /* Hercules Custom Code - End */
                fieldType: "Contextual",
                hideEmptyOption: true,
                /* Hercules Custom Code - Start */
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "None", value: "" },
                    { displayName: "Paragraph", value: "p" },
                    { displayName: "Heading 1", value: "h1" },
                    { displayName: "Heading 2", value: "h2" },
                    { displayName: "Heading 3", value: "h3" },
                    { displayName: "Heading 4", value: "h4" },
                    { displayName: "Heading 5", value: "h5" },
                    { displayName: "Heading 6", value: "h6" },
                ],
                defaultValue: "h2",
                isVisible: x => x.fields.showTitle,
                /* Hercules Custom Code - End */
            },
            /* Valtech Custom Code - End */
            {
                name: fields.showImages,
                displayName: "Show Images",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                // Valtech removed - sortOrder
            },
            {
                name: fields.showOnlyTopLevelCategories,
                displayName: "Show all top-level categories", // Valtech Custom Code
                editorTemplate: "CheckboxField",
                defaultValue: true, // Valtech Custom Code
                fieldType: "General",
                // Valtech removed - sortOrder
            },
            /* Valtech Custom Code - Start */
            {
                name: fields.selectedCategoryIds,
                displayName: "Selected Categories",
                editorTemplate: "CategoriesField",
                defaultValue: [],
                fieldType: "Contextual",
                isVisible: x => !x.fields.showOnlyTopLevelCategories,
            },
            {
                name: fields.showSubCategories,
                displayName: "Show Subcategories",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                isVisible: x => x.fields.variant !== categoryListVariantOptions.compact.id,
            },
            {
                name: fields.subCategoriesToShow,
                displayName: "Maximum subcategories to show",
                editorTemplate: "IntegerField",
                defaultValue: 4,
                fieldType: "Contextual",
                min: 1,
                isVisible: x => {
                    return x.fields.showSubCategories && x.fields.variant !== categoryListVariantOptions.compact.id;
                },
            },
            /* Valtech Custom Code - End */
            /* Hercules Custom Code - Start */
            {
                name: fields.addSpacing,
                displayName: "Add spacing above and below",
                fieldType: "General",
                editorTemplate: "CheckboxField",
                defaultValue: true,
            },
            {
                name: fields.showTitle,
                displayName: "Show List Title",
                fieldType: "General",
                editorTemplate: "CheckboxField",
                defaultValue: true,
            },
            {
                name: fields.forwardAs,
                displayName: "HTML Tag",
                fieldType: "General",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Match Format", value: "" },
                    { displayName: "span", value: "span" },
                    { displayName: "p", value: "p" },
                    { displayName: "h1", value: "h1" },
                    { displayName: "h2", value: "h2" },
                    { displayName: "h3", value: "h3" },
                    { displayName: "h4", value: "h4" },
                    { displayName: "h5", value: "h5" },
                    { displayName: "h6", value: "h6" },
                ],
                defaultValue: "",
                hideEmptyOption: true,
                tooltip: "Set a HTML tag that differs from the visual format for SEO purposes",
                isVisible: x => x.fields.showTitle,
            },
            {
                name: fields.textAlign,
                displayName: "Alignment",
                fieldType: "General",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Left", value: "left" },
                    { displayName: "Center", value: "center" },
                    { displayName: "Right", value: "right" },
                ],
                defaultValue: "left",
                hideEmptyOption: true,
                isRequired: true,
                isVisible: x => x.fields.showTitle,
            },
            /* Hercules Custom Code - End */
        ],
    },
};

export default widgetModule;
